/**
 * SokujiGlyph Component
 *
 * The Sokuji mark as a single-colour icon. It paints `currentColor` through the
 * glyph's alpha mask, so it sits beside lucide icons and follows the same
 * text and active colours, where <Logo> would show the black app tile.
 */

interface SokujiGlyphProps {
  size?: string | number;
  className?: string;
}

export function SokujiGlyph({ size = 24, className }: SokujiGlyphProps) {
  const mask = 'url(/sokuji-glyph.png) center / contain no-repeat';
  return (
    <span
      aria-hidden="true"
      className={className}
      style={{
        display: 'inline-block',
        flexShrink: 0,
        width: size,
        height: size,
        backgroundColor: 'currentColor',
        mask,
        WebkitMask: mask,
      }}
    />
  );
}
